import React, { useState } from 'react';
import VotingCard from './VotingCard';
import { DeckType, DECK_CARDS } from '../types';
import './VotingDeck.css';

interface VotingDeckProps {
  deckType: DeckType;
  onVoteSelect: (value: string) => void;
  /** Called when the already-selected card is clicked again, to withdraw the vote. */
  onVoteRemove?: () => void;
  disabled?: boolean;
  selectedValue?: string;
}

const VotingDeck: React.FC<VotingDeckProps> = ({
  deckType,
  onVoteSelect,
  onVoteRemove,
  disabled = false,
  selectedValue
}) => {
  const [localSelectedValue, setLocalSelectedValue] = useState<string | null>(null);

  const cards = DECK_CARDS[deckType];
  const currentSelection = selectedValue || localSelectedValue;

  const handleCardClick = (value: string) => {
    if (disabled) return;

    // 選択中のカードをもう一度クリックしたら取り消し扱いにする
    if (currentSelection === value && onVoteRemove) {
      setLocalSelectedValue(null);
      onVoteRemove();
      return;
    }

    setLocalSelectedValue(value);
    onVoteSelect(value);
  };

  return (
    <div className={`voting-deck ${deckType}`}>
      <h3 className="deck-title">あなたの見積もりを選択してください</h3>
      <div className="cards-container">
        {cards.map((card, index) => (
          <VotingCard
            key={index}
            value={card}
            isSelected={currentSelection === card}
            onClick={handleCardClick}
            disabled={disabled}
          />
        ))}
      </div>
      {currentSelection && (
        <div className="selected-value">
          <p>
            選択された値: <strong>{currentSelection}</strong>
            {onVoteRemove && !disabled && '（もう一度クリックすると取り消せます）'}
          </p>
        </div>
      )}
    </div>
  );
};

export default VotingDeck;